import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
import { billsRoutes } from './routes';

/** One line of the create-bill body an AP push sent, as appfolio-service reads it back. */

/**
 * The GL accounts one push attempt actually posted to, read from the body persisted at push time.
 * Re-pointing a property's account afterwards does not change this — it reports what was sent.
 */

export class AppfolioBills {
  constructor() {
    _defineProperty(this, "routes", billsRoutes);
  }
  /**
   * What one AP push attempt posted to. 404 for an attempt this company does not own — appfolio-service
   * does not distinguish that from one that does not exist, so neither can this.
   */
  async getPushGlAccounts(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.pushGlAccounts(data.pushAttemptId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSettingsByBillId(data, options) {
    const billId = data.billId;
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get("".concat(this.routes.billSettings, "/").concat(billId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSettingsByBillIdV2(data, options) {
    const billId = data.billId;
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).post("".concat(this.routes.billSettingsV2, "/").concat(billId), {
      allocationCycleYear: data.allocationCycleYear,
      allocationCycleMonth: data.allocationCycleMonth
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postBillSettings(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).post("".concat(this.routes.billSettings), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}